

import { NgModule } from '@angular/core';
import { TabModule, ToolbarModule } from '@syncfusion/ej2-angular-navigations';
import { FilterService, GridModule, GroupService, PageService, SearchService, SortService, ToolbarService, FreezeService, EditService, ResizeService, DetailRowService, CommandColumnService, InfiniteScrollService, PagerModule } from '@syncfusion/ej2-angular-grids';
import { DateTimePickerModule, TimePickerModule } from '@syncfusion/ej2-angular-calendars';
import { DropDownListModule, MultiSelectModule } from '@syncfusion/ej2-angular-dropdowns';
import { RichTextEditorModule, RichTextEditorAllModule } from '@syncfusion/ej2-angular-richtexteditor';
import { CheckBoxModule } from '@syncfusion/ej2-angular-buttons';

@NgModule({
  imports: [
    GridModule,
    TabModule,
    TimePickerModule,
    ToolbarModule,
    DateTimePickerModule,
    MultiSelectModule,
    DropDownListModule,
    RichTextEditorModule,
    RichTextEditorAllModule,
    CheckBoxModule,
    PagerModule,
  ],
  exports: [
    GridModule,
    TabModule,
    TimePickerModule,
    ToolbarModule,
    DateTimePickerModule,
    MultiSelectModule,
    DropDownListModule,
    RichTextEditorModule,
    RichTextEditorAllModule,
    CheckBoxModule,
    PagerModule,
  ],
  providers: [
    PageService,
    SortService,
    SearchService,
    ToolbarService,
    FilterService,
    GroupService,
    FreezeService,
    EditService,
    ResizeService,
    DetailRowService,
    CommandColumnService,
    InfiniteScrollService,
  ]
})
export class SyncfusionModule { }
